var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-size"},[_c('MoreTitle',{attrs:{"title":"基金规模"},on:{"click":_vm.goPage}}),_vm._m(0),_c('VueEcharts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-time"},[_c('span',{staticClass:"time"},[_vm._v("2020-12-31更新")]),_c('span',{staticClass:"unit"},[_vm._v("单位：港元")])])
}]

export { render, staticRenderFns }